module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/hero-fc8d583433c76516425c27f6e42fa1ca.jpg";